import React, {useEffect, useState} from 'react';
import {gql} from "apollo-boost";
import {CircularProgress, List, ListItem, ListItemText, Paper, Typography,} from '@material-ui/core';
import MaterialTable from 'material-table';
import {Alert} from '@material-ui/lab';
import {useQuery} from "@apollo/react-hooks";
import useStyles from '../../styles/styles';
import TableIcons from "../../utils/TableIcons";

/**
 * Could replace the original CloudwatchLogsTable once all leads use the short form lead pattern
 */
const IdentifyEventsTableShortForm = ({apiRequestId}) => {
    const [identityEvents, setIdentityEvents] = useState([]);
    const [columns, setColumns] = useState([]);
    const classes = useStyles();
    const {loading, error, data} = useQuery(gql`
        query IdentityEvents($apiRequestId: UUID!) {
            identityCanonicalIdentityInstanceEvents(
                identityDataSource: LOAN_REQUEST
                apiRequestId: $apiRequestId
            ){
                eventType
                identityInstanceSources {
                    sourceId
                    identityDataSource
                }
            }
        }
    `, {
        variables: {
            apiRequestId: apiRequestId,
        },
        context: {
            clientName: "kgraphql"
        }
    });


    useEffect(() => {
        if (data && Object.keys(data).length) {
            const items = data.identityCanonicalIdentityInstanceEvents;
            setIdentityEvents(items);

            const keyLookup = {};
            items.forEach(event => {
                keyLookup[event.eventType] = event.eventType;
            });

            setColumns([{
                title: 'Key', field: "key", lookup: keyLookup
            },
                {
                    title: 'Loan Request Ids', field: "loanRequestId",
                    render: (rowData) => {
                        return (
                            <List dense style={{height: '250px', overflow: 'scroll'}}>
                                {rowData.loanRequestId.map(item => (
                                    <ListItem
                                        key={item.requestId}
                                        divider
                                        alignItems={"flex-start"}
                                        disableGutters
                                    >
                                        <ListItemText>
                                            <Typography variant="body2">
                                                <a href={`/info/leads/${item.requestId}`} target={"_blank"}>
                                                    {item.requestId}
                                                </a>
                                            </Typography>
                                        </ListItemText>
                                    </ListItem>
                                ))}
                            </List>
                        );
                    }
                }]);
        }
    }, [data]);

    if (loading) {
        return (
            <>
                <Typography variant="h4" component="h4" align="left" id={"cloudwatch-logs"}>Identity Events</Typography>
                <Paper className={classes.paper}>
                    <CircularProgress color="inherit"/>
                </Paper>
            </>
        );
    }

    if (error) {
        return (
            <>
                <Typography variant="h4" component="h4" align="left" id={"cloudwatch-logs"}>Identity Events</Typography>
                <Paper className={classes.paper}>
                    <Alert severity="error">Well, this in embarrassing&hellip; something went wrong.</Alert>
                </Paper>
            </>
        );
    }

    return (
        <>
            <Typography variant="h4" component="h4" align="left" id={"cloudwatch-logs"}>
                Identity Events
            </Typography>
            <Paper className={classes.paper}>
                {data && identityEvents.length !== 0 ? (
                    <MaterialTable
                        title=""
                        icons={TableIcons}
                        columns={columns}
                        data={identityEvents.map(events => ({
                            key: events.eventType,
                            loanRequestId: events.identityInstanceSourceRequestIds,
                        }))}
                        options={{
                            pageSize: 20,
                            filtering: true,
                            pageSizeOptions: [20, 50, 100],
                        }}
                    />
                ) : (
                    <Alert severity="warning">There are no Identity Events at this time.</Alert>
                )}
            </Paper>

        </>
    );
};

export default IdentifyEventsTableShortForm;
